<template>
  <div class="create-goods-template">
    <a-space class="input">
      <span v-if="isShowLabel">选择商品模板：</span>
      <a-select
        v-model:value="goodsTemplateId"
        style="width: 310px"
        dropdownClassName="goods-template-select"
        show-search
        placeholder="请选择1个商品模板，可输入关键字搜索"
        :default-active-first-option="false"
        :filter-option="false"
        not-found-content="未找到商品模板"
        @search="getGoodsTemplateList"
      >
        <a-select-option v-for="item in goodsTemplateList" :key="item.Id" :value="item.Id">
          <span>{{ item.label }}</span>
          <a-button
            v-show="useTemplateType === 'self'"
            type="primary"
            danger
            size="small"
            @click.stop="deleteGoodsTemplate(item)"
            >删除</a-button
          >
        </a-select-option>
      </a-select>
      <a-button v-if="goodsTemplateList?.length" type="primary" @click="editGoodsTemplate"> 查看模板 </a-button>
      <a-button v-if="useTemplateType === 'self'" type="primary" danger @click="addGoodsTemplate"> 添加模板 </a-button>
      <a-button v-if="!hideOpenDouyinButton" type="primary" @click="goDraftPage"> 前往支付宝店铺后台 </a-button>
    </a-space>
    <a-modal
      v-model:visible="visible"
      :title="getModalTitle"
      :maskClosable="false"
      width="990px"
      style="top: 15px"
      class="goods-template-modal"
    >
      <a-spin size="large" :spinning="loading" tip="正在加载数据中，请等待">
        <a-tabs v-show="useTemplateType === 'self'" v-model:activeKey="activeKey">
          <a-tab-pane v-for="item in Options.tabs" :key="item.value" :tab="item.label" />
        </a-tabs>
        <div class="box" :style="{ marginTop: useTemplateType === 'self' ? '' : '1em' }">
          <!-- 商品模板 -->
          <template v-if="activeKey === 'basic-configuration'">
            <div class="row">
              <span>模板名称：</span>
              <a-input
                v-model:value="params.name"
                placeholder="请输入模板名称（必填项）"
                allowClear
                style="margin-right: 44px"
              />
            </div>
            <div class="row">
              <div class="item" style="width: 100%">
                <span class="top-1px">类目设置：</span>
                <a-radio-group v-model:value="params.setCatType">
                  <a-radio v-for="item in Options.category" :key="item.value" :value="item.value">
                    <a-tooltip placement="top">
                      <template #title> 提示: {{ item.tip }} </template>
                      {{ item.label }}
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
                <MallCategorySelect
                  isShowSync
                  :category="params.category"
                  :categoryList="categoryList"
                  @sync-category="(list) => (categoryList = list)"
                  @change="changeCategory"
                />
              </div>
            </div>
            <div class="row">
              <div class="item set-price-box">
                <span>价格设置：</span>
                <div>
                  <div v-for="(platform, index) in Options.price.platform" :key="platform.value">
                    {{ platform.value }}：
                    <a-radio-group style="margin-bottom: 4px" v-model:value="params[platform.key]">
                      <a-radio
                        v-for="option in platform.list"
                        :key="option.value"
                        :value="option.value"
                        :style="platform.value === '淘特' && !index ? 'width: 77px;margin-left: 2px;' : ''"
                      >
                        {{ option.label }}
                      </a-radio>
                    </a-radio-group>
                  </div>
                  <a-tag color="red" style="width: max-content">提示：倍数或递增数可以不填写，也可以只填写一个</a-tag>
                  <span>
                    价格=已选价格 *
                    <a-input-number
                      style="width: 120px"
                      v-model:value="params.priceRatio"
                      :min="0"
                      :max="20"
                      placeholder="请输入倍数"
                    />
                    + <a-input-number style="width: 103px" v-model:value="params.addMoney" placeholder="请输入数字" />
                  </span>
                  <div style="margin-top: 6px">
                    小数处理：
                    <a-tooltip placement="right">
                      <template #title> 采用的是【四舍五入】形式 </template>
                      <a-select v-model:value="params.setDecimal" style="width: 277px">
                        <a-select-option v-for="item in Options.price.setDecimal" :key="item.value" :value="item.value">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-tooltip>
                  </div>
                </div>
              </div>
              <div class="item">
                <span>库存设置：</span>
                <div style="display: flex; flex-wrap: wrap">
                  <a-radio-group style="margin-bottom: 4px" v-model:value="params.stockModifyType">
                    <a-radio v-for="item in Options.stock.modifyType" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-radio>
                  </a-radio-group>
                  <a-input-number
                    v-if="params.stockModifyType === 0"
                    style="width: 343px"
                    v-model:value="params.defaultStock"
                    :min="0"
                    :step="1"
                    placeholder="请输入库存（必填项）"
                  />
                  <a-space v-else>
                    上游库存
                    <a-select v-model:value="params.stockCalcType">
                      <a-select-option v-for="item in Options.stock.calcType" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                    <a-input-number
                      style="width: 195px"
                      v-model:value="params.stockModifyNum"
                      :min="0"
                      :step="1"
                      placeholder="请输入数字（可不填）"
                    />
                  </a-space>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="item">
                <span>运费模板：</span>
                <a-space>
                  <a-select
                    v-model:value="params.freightId"
                    :filter-option="filterSelect"
                    show-search
                    allowClear
                    placeholder="请选择运费模板（必选项）"
                    style="width: 300px"
                    @change="changeFreightTemplate"
                  >
                    <a-select-option v-for="item in freightTemplateList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                  <a-button
                    type="primary"
                    ghost
                    @click="
                      openPage(
                        'https://saas.isaas.com/?productId=sas-230710JsMxnatNEm4juH95Ftg4A9#/dmOnlinemall/merchant/distributionServices/logisticsCostTemplate'
                      )
                    "
                  >
                    运费模板
                  </a-button>
                </a-space>
              </div>
            </div>
            <div class="row">
              <div class="item">
                <span>发布模式：</span>
                <a-radio-group v-model:value="params.isCommit">
                  <a-radio v-for="item in Options.commitType" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div class="item">
                <span>重复发布：</span>
                <a-radio-group v-model:value="params.isRepeat">
                  <a-radio
                    v-for="item in Options.isRepeat"
                    :key="item.value"
                    :value="item.value"
                    :disabled="item.disabled"
                  >
                    {{ item.label }}
                  </a-radio>
                </a-radio-group>
              </div>
            </div>
            <div class="row">
              <div v-if="freightTemplateRuleType !== 2 && params.freightId" class="item">
                <span>商品重量：</span>
                <a-input-number
                  style="width: 283px"
                  v-model:value="params.weight"
                  :min="0"
                  placeholder="请输入商品重量（必填项）"
                />
                &nbsp;
                <a-select v-model:value="params.weightUnit" allowClear>
                  <a-select-option v-for="item in Options.weightUnit" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="row">
              <div class="item" style="width: 50%">
                <span>标题设置：</span>
                <div style="display: flex; flex-direction: column">
                  <a-space style="margin-bottom: 0.3em">
                    <span>
                      添<i style="margin-left: 0.33em" />加<i style="margin-left: 0.33em" />前<i
                        style="margin-left: 0.33em"
                      />缀
                    </span>
                    <a-input v-model:value="params.titlePrefix" placeholder="输入前缀" style="width: 100px" />
                    添加后缀
                    <a-input v-model:value="params.titleSuffix" placeholder="输入后缀" style="width: 100px" />
                  </a-space>
                  <a-space style="margin-bottom: 0.3em">
                    删除关键字
                    <a-tooltip placement="top">
                      <template #title>
                        <span>多个关键词之间用中文逗号或者英文逗号区分, 最多支持 5 个</span>
                      </template>
                      <a-textarea
                        style="width: 276px"
                        v-model:value="params.keywordDel"
                        placeholder="输入关键字，关键词之间用逗号区分"
                        :auto-size="{ minRows: 1, maxRows: 5 }"
                      />
                    </a-tooltip>
                  </a-space>
                  <a-space
                    v-for="(option, index) in params.keywordReplaceArr"
                    :key="index"
                    style="margin-bottom: 0.3em"
                  >
                    替换关键字
                    <a-input placeholder="输入关键字" style="width: 100px" v-model:value="option.oldValue" />
                    <span> 替<i style="margin-left: 0.5em" />换<i style="margin-left: 0.5em" />为 </span>
                    <a-input placeholder="输入关键字" style="width: 100px" v-model:value="option.newValue" />
                    <a-tooltip v-if="index === 0" placement="top">
                      <template #title> 最多支持 5 组替换 </template>
                      <PlusCircleOutlined @click="addReplace(params.keywordReplaceArr)" style="color: #007fff" />
                    </a-tooltip>
                    <DeleteOutlined v-else style="color: red" @click="removeReplace(params.keywordReplaceArr, index)" />
                  </a-space>
                  <a-space style="margin-bottom: 0.3em">
                    当标题超过30个字符时:
                    <a-radio-group v-model:value="params.titleMoreSixtyDeleteType">
                      <a-radio v-for="item in Options.titleMoreDeleteType" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-radio>
                    </a-radio-group>
                  </a-space>
                </div>
              </div>
              <div class="item" style="width: 50%">
                <span>SKU设置：</span>
                <div style="display: flex; flex-direction: column">
                  <a-space style="margin-bottom: 0.3em">
                    删除关键字
                    <a-tooltip placement="top">
                      <template #title>
                        <span>多个关键词之间用中文逗号或者英文逗号区分, 最多支持 5 个</span>
                      </template>
                      <a-textarea
                        style="width: 276px"
                        v-model:value="params.skuKeywordDel"
                        placeholder="输入关键字, 关键词之间用逗号区分"
                        :auto-size="{ minRows: 1, maxRows: 5 }"
                      />
                    </a-tooltip>
                  </a-space>
                  <a-space
                    v-for="(option, index) in params.skuKeywordReplaceArr"
                    :key="index"
                    style="margin-bottom: 0.3em"
                  >
                    替换关键字
                    <a-input placeholder="输入关键字" style="width: 100px" v-model:value="option.oldValue" />
                    <span> 替<i style="margin-left: 0.5em" />换<i style="margin-left: 0.5em" />为 </span>
                    <a-input placeholder="输入关键字" style="width: 100px" v-model:value="option.newValue" />
                    <a-tooltip v-if="index === 0" placement="top">
                      <template #title> 最多支持 5 组替换 </template>
                      <PlusCircleOutlined @click="addReplace(params.skuKeywordReplaceArr)" style="color: #007fff" />
                    </a-tooltip>
                    <DeleteOutlined
                      v-else
                      style="color: red"
                      @click="removeReplace(params.skuKeywordReplaceArr, index)"
                    />
                  </a-space>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="item item2">
                <span>详情图：</span>
                删除前&nbsp;
                <a-input-number v-model:value="params.descImgDeletePre" style="width: 80px" placeholder="请输入数量" />&nbsp;
                张&nbsp;&nbsp;删除后
                <a-input-number v-model:value="params.descImgDeleteSuf" style="width: 80px" placeholder="请输入数量" />&nbsp;
                张&nbsp;&nbsp; 添加首张详情图
                <div>
                  <ImageItem
                    v-if="params.descImgAddPre"
                    :item="imgFile.descImgAddPre"
                    @cropper="showVueCropper($event, 'descImgAddPre')"
                    @delete="deleteImage(params, 'descImgAddPre')"
                    @upload="showUploadComponent('descImgAddPre', params)"
                  />
                  <UploadImage
                    :ref="'uploaddescImgAddPre'"
                    v-show="!params.descImgAddPre"
                    :imgFile="imgFile.descImgAddPre"
                    @upload-image="showVueCropper($event, params, 'descImgAddPre')"
                  />
                </div>
                &nbsp;&nbsp;添加尾部详情图
                <div>
                  <ImageItem
                    v-if="params.descImgAddSuf"
                    :item="imgFile.descImgAddSuf"
                    @delete="deleteImage(params, 'descImgAddSuf')"
                    @upload="showUploadComponent('descImgAddSuf', params)"
                  />
                  <UploadImage
                    :ref="'uploaddescImgAddSuf'"
                    v-show="!params.descImgAddSuf"
                    :imgFile="imgFile.descImgAddSuf"
                    @upload-image="showVueCropper($event, params, 'descImgAddSuf')"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="item" style="width: 60%">
                <span>低价引流：</span>
                <div>
                  <a-checkbox v-model:checked="params.skuLowPriceStatus" style="font-size: 15px"
                    >启用SKU低价引流方式</a-checkbox
                  >
                  <div v-show="params.skuLowPriceStatus">
                    当SKU数量大于
                    <a-input-number v-model:value="params.skuNumLow" style="width: 120px" placeholder="请输入数量" />
                    时， 设置最低价SKU的库存为
                    <a-input-number
                      v-model:value="params.firstSkuStock"
                      style="width: 120px"
                      placeholder="请输入库存"
                    />
                    <div style="margin-top: 0.4em">
                      最低价SKU的价格为：来源SKU价格 *
                      <a-input-number
                        style="width: 120px"
                        v-model:value="params.firstPriceRatio"
                        :min="0"
                        placeholder="请输入倍数"
                      />
                      +
                      <a-input-number
                        style="width: 120px"
                        v-model:value="params.firstAddMoney"
                        placeholder="请输入数字"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-show="useTemplateType === 'self'" class="row">
              <ProhibitedWordFiltering ref="prohibitedWordFiltering" class="item" style="width: 89%" />
            </div> -->
            <div v-show="useTemplateType === 'self'" class="row" style="margin-bottom: 0; margin-top: 8px">
              <a-tag v-show="params.is_default" color="blue" style="font-size: 15px"> 已设为默认模板 </a-tag>
              <a-button
                v-show="!params.is_default && getOperateType === '编辑'"
                type="primary"
                @click="setDefaultTemplate"
              >
                设置为默认模板
              </a-button>
              <a-checkbox
                class="set-default-and-use-template"
                v-show="getOperateType === '添加'"
                v-model:checked="params.setDefaultAndUse"
              >
                设置为默认模板并使用
              </a-checkbox>
            </div>
          </template>
          <!-- 属性预设 -->
          <AttributePreset v-else-if="activeKey === 'property'" />
          <!-- 跳过配置 -->
          <JumpSetup v-show="false && activeKey === 'jump-setup'" ref="jumpSetup" />
        </div>
      </a-spin>
      <a-modal
        class="header-fixed-modal"
        width="900px"
        v-model:visible="cropperVisible"
        title="裁剪图片"
        :footer="false"
        style="top: 0"
      >
        <CropperImageModal
          :aspectRatio="imgFile[this.uploadImgType].type === 'longImage' ? 3 / 4 : 1"
          :autoCropArea="imgFile[this.uploadImgType].type === 'longImage' ? 1 : 0.98"
          :imgFile="imgFile[this.uploadImgType]"
          @cropper="cropperSuccess"
          @close="cropperVisible = false"
        />
      </a-modal>
      <template #footer>
        <div v-if="(useTemplateType === 'self' && activeKey === 'basic-configuration') || activeKey === 'jump-setup'">
          <a-button type="primary" :loading="loading" @click="operateGoodsTemplate">确定{{ getOperateType }}</a-button>
          <a-button :loading="loading" @click="visible = false">取消{{ getOperateType }}</a-button>
        </div>
        <a-button v-else type="primary" ghost @click="visible = false">关闭窗口</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
// import ProhibitedWordFiltering from './prohibited_word_filtering'
import handler from "./handler";
import AttributePreset from "./attribute_preset";
import JumpSetup from "./jump_setup";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons-vue";
import { Options } from "./options";
import { mapGetters } from "vuex";
import MallCategorySelect from "../mall_category_select2";
//import categoryApi from "@/views/moving_function/components/mall_category_select2/api";
import CropperImageModal from "@/views/moving_function/views/shipping_preview_list/components/goods_item/vue_cropper";
import ImageItem from "@/views/moving_function/views/shipping_preview_list/components/goods_item/image_item";
import UploadImage from "@/views/moving_function/views/shipping_preview_list/components/goods_item/upload_image";
import store from "@/store";
export default {
  props: {
    hideOpenDouyinButton: {
      type: Boolean,
    },
    isShowLabel: {
      type: Boolean,
      default: true,
    },
    useTemplateType: {
      type: String,
      default: "self",
    },
  },
  components: {
    CropperImageModal,
    ImageItem,
    UploadImage,
    PlusCircleOutlined,
    DeleteOutlined,
    JumpSetup,
    AttributePreset,
    MallCategorySelect,
  },
  data() {
    return {
      imgFile: { descImgAddPre: {}, descImgAddSuf: {} },
      visible: false,
      cropperVisible: false,
      uploadImgType: "descImgAddPre", //当前选中的首图或尾图名
      params: {},
      categoryList: [],
      goodsTemplateId: null,
      loading: true,
      goodsTemplateList: [],
      freightTemplateList: [],
      freightTemplateRuleType: null,
      activeKey: "basic-configuration",
      uploadSpinning: {
        desc_img_add_pre: false,
        desc_img_add_suf: false,
      },
      Options,
    };
  },
  emits: ["success"],
  computed: {
    ...mapGetters({
      checkMall: "mall_group/checkMall",
    }),
    getOperateType() {
      return this.params.id ? "编辑" : "添加";
    },
    getModalTitle() {
      if (this.useTemplateType === "self") return this.getOperateType + "商品模板";
      return `平台推荐推荐模板 - ${this.params.name}`;
    },
  },
  methods: {
    // 搜索-下拉列表
    filterSelect(input, option) {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 切换商品分类
    changeCategory(category) {
      this.params.category = category;
    },
    // 添加 / 编辑 商品模板
    operateGoodsTemplate() {
      handler.CreateOrEditGoodsTemplate(this);
    },
    // 设置为默认模板
    setDefaultTemplate() {
      handler.SetDefault(this);
    },
    // 前往支付宝店铺后台
    goDraftPage() {
      window.open(
        "https://saas.isaas.com/?productId=sas-230710JsMxnatNEm4juH95Ftg4A9#/dmOnlinemall/merchant/workbench"
      );
    },
    // 编辑商品模板
    editGoodsTemplate() {
      if (!this.goodsTemplateId) return this.$message.warning("请先选择一个商品模板");
      handler.EditGoodsTemplate(this);
    },
    // 新增商品模板
    addGoodsTemplate() {
      handler.AddGoodsTemplate(this);
    },
    // 获取商品模板列表 （下拉框）
    async getGoodsTemplateList(val, isGetDefaultTemplate) {
      this.goodsTemplateList = await handler.GetGoodsTemplate(val, isGetDefaultTemplate);
    },
    // 获取运费模板列表 （下拉框）
    async getFreightTemplateList() {
      this.freightTemplateList = await handler.GetFreightTemplate();
    },
    // 改变运费模板
    changeFreightTemplate() {
      this.freightTemplateRuleType =
        this.freightTemplateList.find((item) => item.id === this.params.freight_id)?.rule_type || null;
    },
    // 删除商品模板
    async deleteGoodsTemplate(item) {
      await handler.DeleteTemplate(this, item);
      this.getGoodsTemplateList();
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode;
    },
    // 添加 标题/sku 替换关键词
    addReplace(item) {
      if (item.length === 5) return this.$message.warning("替换关键字最多支持 5 个");
      item.push({ oldValue: "", newValue: "" });
    },
    // 删除 标题/sku 替换关键词
    removeReplace(item, index) {
      item.splice(index, 1);
      this.$message.success("删除替换关键字成功");
    },
    // 获取相关数据
    async getData() {
      this.getFreightTemplateList();
      const params = this.params;
      if (params.freight_id) this.changeFreightTemplate();
      this.loading = false;
      if (!this.categoryList?.length) {
        // const { list, msg, success } = await categoryApi.GetGoodsCategoryList();
        const { list, success, msg } = await store.dispatch("mall_group/getMallCategory");
        if (!success) this.$message.warn(`获取店铺分类失败，原因:【${msg}】`);
        this.categoryList = list;
      }
    },
    //添加收尾详情图
    showUploadComponent(id) {
      this.uploadImgType = id;
      this.$refs["upload" + id].click();
      // document.querySelector(`#${id}`).click()
    },
    //图片裁剪返回
    cropperSuccess(imgUrl) {
      const obj = this.imgFile;
      const imageElement = new Image();
      obj[this.uploadImgType].img = imgUrl;
      obj[this.uploadImgType].item[this.uploadImgType] = imgUrl;
      imageElement.src = imgUrl;
      imageElement.onload = () => {
        obj[this.uploadImgType].width = imageElement.width;
        obj[this.uploadImgType].height = imageElement.height;
        obj[this.uploadImgType].isUpdate = true;
        obj[this.uploadImgType].item[this.uploadImgType + "IsUpdate"] = true;
      };
      this.cropperVisible = false;
      this.$message.success("已成功完成裁剪图片");
    },
    //打开图片裁剪
    showVueCropper(obj, item, id) {
      this.uploadImgType = id;
      this.cropperVisible = true;
      this.imgFile[this.uploadImgType] = obj;
      this.imgFile[this.uploadImgType].item = item;
    },
    //删除详情图
    deleteImage(params, id) {
      params[id] = "";
      params[id + "IsUpdate"] = false;
    },
    openPage(url) {
      url && open(url);
    },
    async initTemplateData(value, getDefaultTemplate) {
      await this.getGoodsTemplateList(value, getDefaultTemplate);
      if (this.goodsTemplateList?.length) this.params.id = this.goodsTemplateId = this.goodsTemplateList[0].Id;
    },
  },
  watch: {
    async visible(val) {
      if (val) {
        this.activeKey = "basic-configuration";
        this.loading = true;
        this.getData();
      }
    },
    checkMall() {
      this.initTemplateData();
    },
  },
  mounted() {
    this.initTemplateData();
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
<style lang="less">
@import "./index2";
</style>
